const mapStateToProps = (state) => {
    const {
        // ui: {
        //     selectedGeoObjArray,
        //     rangeStartDate,
        //     rangeEndDate,
        // } = {},
        api: {
            geoObjRoute,
        } = {},
        // service: {
        //     Api: {
        //         getMultiGeoObjReportExcel,
        //     } = {}
        // } = {}
    } = state;
    return {
        // selectedGeoObjArray,
        // rangeStartDate,
        // rangeEndDate,
        // getMultiGeoObjReportExcel,
        geoObjRoute,
    }
}

export default mapStateToProps